export default "__VITE_ASSET__p$4lB_O5__"